import Icon from '@mui/icons-material/Movie';

import { CreateRails } from './CreateRails';
import { EditRails } from './EditRails';
import { ListRails } from './ListRails';

export const RailsResourceConfig = {
  list: ListRails,
  create: CreateRails,
  edit: EditRails,
  icon: Icon,
  name: 'rails',
};
